import "./App.css";
import "./AppMobile.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { connect } from "react-redux";
import "dropify/dist/js/dropify.js";
import "dropify/dist/css/dropify.css";
import { routers } from "./Constants/routers";
import React from "react";
import { refreshUser } from "./Redux/User/actions";
import HomePage from "./Apps/home/HomePage";
import SearchEngine from "./Apps/search/SearchEngine";
import DoctorPage from "./Apps/doctor/DoctorPage";
import BecomeSpecialist from "./Apps/doctor/BecomeSpecialist";
import Login from "./Apps/auths/Login";
import MyPatients from "./Apps/doctor/secure/MyPatients";
import MyAppointments from "./Apps/doctor/secure/MyAppointments";
import Messanger from "./Apps/chat/Messanger";
import MedicalHistory from "./Apps/patient/MedicalHistory";
import DashboardSwitcher from "./Apps/dashboards/DashboardSwitcher";
import MyFavourites from "./Apps/patient/MyFavourites";
import Register from "./Apps/auths/Register";
import PasswordResetRequest from "./Apps/auths/PasswordResetRequest";
import AccountProfile from "./Apps/profile/AccountProfile";
import ServiceProfile from "./Apps/profile/ServiceProfile";
import WalletOverview from "./Apps/wallet/WalletOverview";
import MedicalProfile from "./Apps/profile/MedicalProfile";
import Schedulers from "./Apps/doctor/secure/Schedulers";
import MedicalProfile2ndOpinion from "./Apps/profile/MedicalProfile2ndOpinion";
import PasswordResetConfirm from "./Apps/auths/PasswordResetConfirm";
import MedicalProfile2ndOpinionAdmin from "./Apps/profile/MedicalProfile2ndOpinionAdmin";
import SearchEngineV2 from "./Apps/search/SearchEngineV2";
import AdminViewController from "./Apps/admin/AdminViewController";
import VideoCall from "./Apps/videocall";
import ErrorPage from "./Components/ErrorPage";
import ManagePermissions from "./Apps/patient/ManagePermissions";

function App(props) {

  React.useEffect(() => {
      props?.refreshUser();
  }, []);

	return (
		<Router>
			<Routes>
        <Route path={routers.pages.home} element={<HomePage />} />
        <Route path={routers.pages.search()} element={<SearchEngineV2 />} />
        <Route path={routers.pages.searchv2()} element={<SearchEngine />} />
        <Route path={routers.pages.doctor(":username")} element={<DoctorPage />} />
        <Route path={routers.pages.becomespecialist} element={<BecomeSpecialist />} />
        
        
        {/* Auths */}
        <Route path={routers.auth.login} element={<Login />} />
        <Route path={routers.auth.register} element={<Register />} />
        <Route path={routers.auth.password_reset} element={<PasswordResetRequest />} />
        <Route path={routers.auth.password_reset_confirm} element={<PasswordResetConfirm />} />

        {/* Specialists */}
        <Route path={routers.dashboard.base} element={<DashboardSwitcher />} />
        <Route path={routers.dashboard.patients} element={<MyPatients />} />
        <Route path={routers.dashboard.appointments} element={<MyAppointments />} />
        <Route path={routers.account.billing} element={<WalletOverview />} />
        <Route path={routers.dashboard.scheduler} element={<Schedulers />} />

        {/* Patients */}
        <Route path={routers.dashboard.medicalhistory} element={<MedicalHistory />} />
        <Route path={routers.dashboard.medicalrecord} element={<MedicalProfile />} />
        <Route path={routers.dashboard.favourites} element={<MyFavourites />} />
        
        {/* Messaging */}
        <Route path={routers.dashboard.messanger("")} element={<Messanger />} />
        <Route path={routers.dashboard.messanger(":currentUser")} element={<Messanger />} />
        
        {/* Profile */}
        <Route path={routers.dashboard.profile} element={<AccountProfile />} />
        <Route path={routers.dashboard.services} element={<ServiceProfile />} />
        <Route path={routers.dashboard.permissions} element={<ManagePermissions />} />
        
        
        <Route path={routers.dashboard.medicalrecord_2nd} element={<MedicalProfile2ndOpinion />} />
        <Route path={routers.dashboard.medicalrecord_2nd_admin} element={<MedicalProfile2ndOpinionAdmin />} />
        <Route path={routers.admin.app_view} element={<AdminViewController />} />
        
        <Route path={routers.others.video_call(':meeting_id')} element={<VideoCall />} />
        <Route path="*" element={<ErrorPage />} />
			</Routes>
		</Router>
	);
}

const mapStateToProps = state => {
  return { user: state.user }
}

const mapDispatchToProps = dispatch => {
  return {
    refreshUser: () => dispatch(refreshUser()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)


